/**
 * Who drove an audit event. Only the Opportunity audit log populates this;
 * the Clients API audit endpoints do not, which is why it is optional.
 */
export type AuditActorCategory = 'Broker' | 'Customer' | 'System';

export const AUDIT_ACTOR_CATEGORY_ALL = 'All';

export type AuditActorFilter = typeof AUDIT_ACTOR_CATEGORY_ALL | AuditActorCategory;

export interface AuditLogEvent {
  id: number;
  timestamp: string; // Instant as string
  author: string;
  actorCategory?: AuditActorCategory;
  /** Fact Find participant the event concerns, when it is participant-scoped. */
  participantName?: string;
  eventType: string;
  eventDetails: any; // JSON object
}

export enum EntityType {
  OPPORTUNITY = 'opportunity',
  LEAD = 'lead',
  INDIVIDUAL = 'individual',
  COMPANY = 'company',
  TRUST = 'trust'
} 